<!--
    BD Dunning-Proposal Object Component
    Read-only detail view of a dunning proposal (bd.DunningProposal). The data widget
    renders the backend FormObject field groups (Allgemein/Saldo/Freigabe/Verarbeitung/
    Verknüpfungen/Technische Daten).
-->
@if (initialized && dto) {
    <div class="bd-dunning-proposal-object p-2">
        @if (proposalDataWidget) {
            <mvs-widget [widgetData]="proposalDataWidget"></mvs-widget>
        }
    </div>
}
